import React, { useState } from "react";
import styled from "styled-components";
import Particle from "../Particle";
import { FaMobileAlt, FaLaptop, FaFilter } from "react-icons/fa";

const ProjectsContainer = styled.div`
  position: relative;
  padding-top: 30px;
  overflow: hidden;
`;

const ProjectGrid = styled.div`
  margin-top: 100px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 3%;
  position: relative;
  z-index: 2;
`;

const ProjectBox = styled.a`
  display: block;
  background-color: #1c1c28;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  text-decoration: none;
  color: inherit;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 15px;
  }

  h3 {
    color: #c770f0;
    margin-bottom: 10px;
    font-size: 1.5rem;
  }

  p {
    color: #ddd;
    font-size: 1rem;
    line-height: 1.5;
  }

  span {
    display: inline-block;
    margin-top: 15px;
    color: #c770f0;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;

    &:hover {
      color: #a45fdb;
    }
  }
`;

const FilterButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 60px;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;
const Button = styled.button`
  padding: 10px 20px;
  background-color: ${(props) =>
    props.active ? "#c770f0" : "#f4f4f4"}; /* Active purple vs default */
  color: ${(props) => (props.active ? "#fff" : "#7a7a7a")}; /* Text color */

  border: none;
  border-radius: 20px; /* Rounded corners */
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: bold;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center; /* Ensures everything centers properly */

  /* Removed gap between icon and text */
  svg {
    margin-right: 8px; /* Adjust the spacing between icon and text manually */
  }
&:hover {
  background-color: ${(props) =>
    props.active ? "#c770f0" : "#e1e1e1"}; /* Hover effect */
}


  /* Mobile responsiveness */
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 0.75rem;
  }
`;

const SomeProjects = () => {
  const [filter, setFilter] = useState("all");

  const projects = [
    {
      title: "Al Quran Portal App/Web",
      description:
        "Al Quran Portal is a digital app for easy academy management, with student tracking, ID cards, and admission forms—access your portal anytime, anywhere",
      img: "https://i.postimg.cc/FRf4NWDn/Home-Screen.png",
      link: "https://alquranportal.vercel.app/",
      category: "app",
    },
    {
      title: "Tasbih360 App/Web",
      description:
        "Tasbih360 is a digital app for easy Zikr, with auto-counting, history, and customization—do Tasbih anytime, anywhere.",
      img: "https://i.postimg.cc/RVVmbXC9/Whats-App-Image-2025-06-16-at-00-38-15-a66b8eda.jpg",
      link: "https://tasbih360.netlify.app/",
      category: "app",
    },
    {
      title: "Facebook UI App/Web",
      description:
        "I have designed a Facebook UI that easily adjusts to any screen size. This design focuses solely on clean and visually appealing layouts and components",
      img: "https://i.postimg.cc/CLzCJJDZ/FB-clone.png",
      link: "https://cozy-dodol-88dcef.netlify.app/",
      category: "app",
    },
    {
      title: "MobileMart App/Web",
      description:
        "Mobile shopping platform for electronics and accessories.Fully function UI/UX",
      img: "https://i.postimg.cc/yN3DVkd8/Mobile-Mart.png",
      link: "https://ameerhamzarafiq.github.io/AnDroiDX.shop/",
      category: "app",
    },
    {
      title: "Weather App/Web",
      description: "Check weather for different countries.Fully function UI/UX",
      img: "https://i.postimg.cc/YSFQdXQR/Weather-app.png",
      link: "https://ameerhamzarafiq.github.io/weather-app/",
      category: "app",
    },
    {
      title: "Stop Watch  App/Web",
      description: "stopTimer Watch to track time.Fully function UI/UX",
      img: "https://i.postimg.cc/8PxssjQ5/image-2024-09-15-170355394.png",
      link: "https://ameerhamzarafiq.github.io/Stop-Timer-Watch/",
      category: "app",
    },
    {
      title: "Shopping Mart  App/Web",
      description:
        "A modern eCommerce platform built with Redux Toolkit for seamless shopping.",
      img: "https://i.postimg.cc/1Xd3wBn1/Shopping-mart.png",
      link: "https://65cd0158ad5f4b0b3115393e--heroic-salamander-fabe70.netlify.app",
      category: "app",
    },
    {
      title: "GenerateTable App/Web",
      description: "0ne To Uncountable",
      img: "https://i.postimg.cc/zBqcPKVy/Table-Ganetor.png",
      link: "https://ameerhamzarafiq.github.io/GenerateTable-0neToUncountable/",
      category: "app",
    },
    {
      title: "Saltn-Papper UI Only_Web",
      description:
        "'Run the program on PC' A food delivery service platform. Only UI design",
      img: "https://i.postimg.cc/RVY21gd3/sult-and-ppr.png",
      link: "https://ameerhamzarafiq.github.io/SaltN-PappeR/",
      category: "web",
    },
    {
      title: "NOON UI App/Web",
      description:
        "'Run the program on PC', E_commerce platform for electronics, fashion, and home essentials. Only UI design",
      img: "https://i.postimg.cc/43Pg1Jqw/noonApp.png",
      link: "https://ameerhamzarafiq.github.io/Noon.com/",
      category: "web",
    },
    {
      title: "TodoApp-firebase",
      description:
        "A dynamic task management app powered by Firebase and Firestore, allowing logged-in users to securely store data and view their personalized tasks in real-time.",
      img: "https://i.postimg.cc/xCmRLSyd/Todo-firbase.png",
      link: "https://ameerhamzarafiq.github.io/TodoApp-firebase-firestore/",
      category: "app",
    },
    {
      title: "Bulb on/off App/Web",
      description:
        "A simple interactive app where the bulb turns on when you hover the cursor over it and turns off when the cursor moves away.",
      img: "https://i.postimg.cc/8z9LNdt3/Bulb-on-off.png",
      link: "https://ameerhamzarafiq.github.io/Bulb-On-Off/",
      category: "app",
    },
    {
      title: "Screen Color change",
      description: "Only Screen Color change",
      img: "https://i.postimg.cc/4yswQ97F/color-change.png",
      link: "https://ameerhamzarafiq.github.io/Body-color-change-in-javascript/",
      category: "app",
    },
    {
      title: "Calender",
      description: "UI design for a calendar.",
      img: "https://i.postimg.cc/wBk1sRzB/calender.png",
      link: "https://ameerhamzarafiq.github.io/calender-2023./index(2).html",
      category: "web",
    },
    {
      title: "Tasla Car Nawes  App/Web",
      description: "News app for car-related news (API issue).",
      img: "https://i.postimg.cc/HkXGdmmC/Tasla-Car.png",
      link: "https://ameerhamzarafiq.github.io/news-app/",
      category: "web",
    },
  ];

  // Filter projects based on category
  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <ProjectsContainer>
      {/* start Particle background */}
      <Particle />

      {/* Filter buttons */}
      <FilterButtons>
        <Button active={filter === "app"} onClick={() => setFilter("app")}>
          <FaMobileAlt />
          App
        </Button>
        <Button active={filter === "web"} onClick={() => setFilter("web")}>
          <FaLaptop />
          Web
        </Button>
        <Button active={filter === "all"} onClick={() => setFilter("all")}>
          <FaFilter />
          All
        </Button>
      </FilterButtons>

      <ProjectGrid>
        {filteredProjects.map((project, index) => (
          <ProjectBox
            key={index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={project.img} alt={project.title} />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <span>View Project</span>
          </ProjectBox>
        ))}
      </ProjectGrid>
    </ProjectsContainer>
  );
};

export default SomeProjects;
